import { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
import type { WorkstationHealthReport } from '../shared/desktop-api';
import { TooltipButton } from './TooltipButton';
import { speedBoostSummary } from './customer-health-report';
import './performance-workspace.css';

export const speedBoostStatus = speedBoostSummary;

/** Uses the same cached report and live notifications as Computer check.
 * The status bar stays quiet: the light appears only when speed boost needs attention. */
export function SpeedBoostButton() {
  const [report, setReport] = useState<WorkstationHealthReport | null>(null);
  useEffect(() => {
    let live = true,
      pushed = false;
    const api = window.capturePointDesktop;
    const stop = api?.onWorkstationHealthChanged((next) => {
      pushed = true;
      if (live) setReport(next);
    });
    void api
      ?.getWorkstationHealth()
      .then((next) => {
        if (live && !pushed) setReport(next);
      })
      .catch(() => undefined);
    return () => {
      live = false;
      stop?.();
    };
  }, []);
  const status = speedBoostStatus(report);
  if (status.mode !== 'partial' && status.mode !== 'attention') return null;
  return (
    <TooltipButton
      className={`speed-boost-status ${status.mode}`}
      type="button"
      aria-label={`Speed boost: ${status.label.toLowerCase()}. Open Performance`}
      tooltip={`Speed boost ${status.label.toLowerCase()}`}
      onClick={() => window.dispatchEvent(new Event('capturepoint-open-performance'))}
    >
      <Zap size={20} aria-hidden="true" />
    </TooltipButton>
  );
}
